import { lazy } from 'react';

export const dynamicImportAgnostic = (importFn, options = { ssr: false }) => {
  if (typeof window === 'undefined' && options.ssr === false) {
    // Return a dummy component for SSR when ssr is false
    return () => null;
  }
  return lazy(importFn);
};
